<template>
    <div class="flex flex-col items-center lg:items-start mb-4 lg:mb-0 lg:mr-6">
        <cUtilsEdit v-if="footer.logo" @edit="goToStylesField('footerLogo')">
            <a :href="footer.logoLink" @click.prevent="goToLink(footer.logoLink)">
                <img class="h-8" :src="footer.logo" alt="footer logo" />
            </a>
        </cUtilsEdit>

        <cAddressCol class="mt-4" v-if="renderContact" :footer="footer" />
        <cSocials v-if="renderSocials" class="mt-4" :footer="footer" />
    </div>
</template>

<script>
import cAddressCol from "./cAddressCol.vue";
import cSocials from "./cSocials.vue";
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "cLogo",
    components: {
        cAddressCol,
        cSocials,
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToStylesField } = useLegalGoTo();
        return {
            goToLink,
            goToStylesField,
        };
    },
    props: {
        footer: Object,
    },
    computed: {
        renderContact() {
            return this.footer.contactInfo && this.footer.contactLayout === "col";
        },
        renderSocials() {
            return this.footer.newsletter && this.footer.newsletterLayout === "mini";
        },
    },
};
</script>
